import { DataTableDetailOrderController } from '../../hook/DataTableDetailOrderController';

const useDataTableDetailOrderController = (props, transactionId) => {
  return DataTableDetailOrderController(props, transactionId);
};

export default useDataTableDetailOrderController;
